var _linearGradient, _linearGradient2, _filter, _linearGradient3, _radialGradient, _clipPath, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _g, _rect, _rect2, _path, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 96,
    width: 96,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 36.357143,
    x2: 36.357143,
    xlinkHref: "#a",
    y1: 6,
    y2: 63.893143
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    colorInterpolationFilters: "sRGB",
    height: 1.384,
    width: 1.384,
    x: -0.192,
    y: -0.192
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.28
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 48,
    x2: 48,
    xlinkHref: "#a",
    y1: 20.220806,
    y2: 138.66119
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 48,
    cy: 90.171875,
    gradientTransform: "matrix(1.1573129 0 0 .99590774 -7.551021 .197132)",
    gradientUnits: "userSpaceOnUse",
    r: 42,
    xlinkHref: "#a"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 84,
    rx: 6,
    width: 84,
    x: 6,
    y: 6
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 48,
    x2: 48,
    y1: 90,
    y2: 5.987717
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f2b1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#553a23"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientTransform: "matrix(1.0058652 0 0 .994169 100 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 45.447727,
    x2: 45.447727,
    y1: 92.539597,
    y2: 7.01654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.588235
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientTransform: "matrix(1.0238095 0 0 1.0119048 -1.142857 -98.071429)",
    gradientUnits: "userSpaceOnUse",
    x1: 32.251034,
    x2: 32.251034,
    xlinkHref: "#h",
    y1: 6.131708,
    y2: 90.238609
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientTransform: "translate(0 -97)",
    gradientUnits: "userSpaceOnUse",
    x1: 32.251034,
    x2: 32.251034,
    xlinkHref: "#h",
    y1: 6.131708,
    y2: 90.238609
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12-95.03125c-5.5110903 0-10.03125 4.52016-10.03125 10.03125v71c0 5.5110902 4.5201598 10.03125 10.03125 10.03125h72c5.51109 0 10.03125-4.5201597 10.03125-10.03125v-71c0-5.51109-4.52016-10.03125-10.03125-10.03125z",
    opacity: 0.08,
    transform: "scale(1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12-94.03125c-4.971633 0-9.03125 4.059617-9.03125 9.03125v71c0 4.9716329 4.0596171 9.03125 9.03125 9.03125h72c4.971633 0 9.03125-4.059617 9.03125-9.03125v-71c0-4.971633-4.059617-9.03125-9.03125-9.03125z",
    opacity: 0.1,
    transform: "scale(1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12-93c-4.4091333 0-8 3.590867-8 8v71c0 4.4091333 3.5908667 8 8 8h72c4.409133 0 8-3.5908667 8-8v-71c0-4.409133-3.590867-8-8-8z",
    opacity: 0.2,
    transform: "scale(1 -1)"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 85,
    opacity: 0.3,
    rx: 7,
    transform: "scale(1 -1)",
    width: 86,
    x: 5,
    y: -92
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#j)",
    height: 84,
    opacity: 0.45,
    rx: 6,
    transform: "scale(1 -1)",
    width: 84,
    x: 6,
    y: -91
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#g)",
    height: 84,
    rx: 6,
    width: 84,
    x: 6,
    y: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 6c-3.324 0-6 2.676-6 6v2 68 2c0 .334721.04135.6507.09375.96875.0487.295596.09704.596915.1875.875.00988.03038.020892.0636.03125.09375.098865.287771.2348802.547452.375.8125.1445918.273507.3156161.535615.5.78125s.3737765.473472.59375.6875c.439947.428056.94291.814526 1.5 1.09375.278545.139612.5734731.246947.875.34375-.2562018-.100222-.4867109-.236272-.71875-.375-.00741-.0044-.023866.0045-.03125 0-.031933-.0193-.062293-.04251-.09375-.0625-.120395-.0767-.2310226-.163513-.34375-.25-.1061728-.0808-.2132809-.161112-.3125-.25-.1779299-.161433-.3474596-.345388-.5-.53125-.1075789-.130255-.2183939-.265285-.3125-.40625-.025089-.03838-.038446-.08587-.0625-.125-.064763-.103032-.1302275-.204517-.1875-.3125-.1010083-.194706-.2056748-.415701-.28125-.625-.00796-.02181-.023589-.04055-.03125-.0625-.0318251-.09195-.0358045-.186831-.0625-.28125-.0303323-.106618-.0703894-.203031-.09375-.3125-.0728786-.341512-.125-.698205-.125-1.0625v-2-68-2c0-2.781848 2.2181517-5 5-5h2 68 2c2.781848 0 5 2.218152 5 5v2 68 2c0 .364295-.05212.720988-.125 1.0625-.04415.206893-.08838.397658-.15625.59375-.0077.02195-.0233.04069-.03125.0625-.06274.173739-.138383.367449-.21875.53125-.04158.0828-.07904.169954-.125.25-.0546.09721-.126774.18835-.1875.28125-.09411.140965-.204921.275995-.3125.40625-.143174.17445-.303141.346998-.46875.5-.01117.0102-.01998.02115-.03125.03125-.138386.125556-.285091.234436-.4375.34375-.102571.07315-.204318.153364-.3125.21875-.0074.0045-.02384-.0044-.03125 0-.232039.138728-.462548.274778-.71875.375.301527-.0968.596455-.204138.875-.34375.55709-.279224 1.060053-.665694 1.5-1.09375.219973-.214028.409366-.441865.59375-.6875s.355408-.507743.5-.78125c.14012-.265048.276135-.524729.375-.8125.01041-.03078.02133-.06274.03125-.09375.09046-.278085.1388-.579404.1875-.875.0524-.31805.09375-.634029.09375-.96875v-2-68-2c0-3.324-2.676-6-6-6z",
    fill: "url(#b)",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 90c-3.324 0-6-2.676-6-6v-2-68-2c0-.334721.04135-.6507.09375-.96875.0487-.295596.09704-.596915.1875-.875.00988-.03038.020892-.0636.03125-.09375.098865-.287771.2348802-.547452.375-.8125.1445918-.273507.3156161-.535615.5-.78125s.3737765-.473472.59375-.6875c.439947-.428056.94291-.814526 1.5-1.09375.278545-.139612.5734731-.246947.875-.34375-.2562018.100222-.4867109.236272-.71875.375-.00741.0044-.023866-.0045-.03125 0-.031933.0193-.062293.04251-.09375.0625-.120395.0767-.2310226.163513-.34375.25-.1061728.0808-.2132809.161112-.3125.25-.1779299.161433-.3474596.345388-.5.53125-.1075789.130255-.2183939.265285-.3125.40625-.025089.03838-.038446.08587-.0625.125-.064763.103032-.1302275.204517-.1875.3125-.1010083.194706-.2056748.415701-.28125.625-.00796.02181-.023589.04055-.03125.0625-.0318251.09195-.0358045.186831-.0625.28125-.0303323.106618-.0703894.203031-.09375.3125-.0728786.341512-.125.698205-.125 1.0625v2 68 2c0 2.781848 2.2181517 5 5 5h2 68 2c2.781848 0 5-2.218152 5-5v-2-68-2c0-.364295-.05212-.720988-.125-1.0625-.04415-.206893-.08838-.397658-.15625-.59375-.0077-.02195-.0233-.04069-.03125-.0625-.06274-.173739-.138383-.367449-.21875-.53125-.04158-.0828-.07904-.169954-.125-.25-.0546-.09721-.126774-.18835-.1875-.28125-.09411-.140965-.204921-.275995-.3125-.40625-.143174-.17445-.303141-.346998-.46875-.5-.01117-.0102-.01998-.02115-.03125-.03125-.138386-.125556-.285091-.234436-.4375-.34375-.102571-.07315-.204318-.153364-.3125-.21875-.0074-.0045-.02384.0044-.03125 0-.232039-.138728-.462548-.274778-.71875-.375.301527.0968.596455.204138.875.34375.55709.279224 1.060053.665694 1.5 1.09375.219973.214028.409366.441865.59375.6875s.355408.507743.5.78125c.14012.265048.276135.524729.375.8125.01041.03078.02133.06274.03125.09375.09046.278085.1388.579404.1875.875.0524.31805.09375.634029.09375.96875v2 68 2c0 3.324-2.676 6-6 6z",
    fill: "url(#e)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 66,
    rx: 12,
    style: {
      opacity: 0.05,
      stroke: "#fefefe",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      clipPath: "url(#f)",
      fill: "url(#d)",
      filter: "url(#c)"
    },
    transform: "translate(-128 2)",
    width: 66,
    x: 15,
    y: 15
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.449905
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-79.337731 80.436783c-.154394-1.17538-.443634-2.986674-.642753-4.025106-.239048-1.246645-.155789-2.683162.245073-4.228528.670003-2.582937 1.073171-3.293878 1.073171-1.892418 0 .502769.415776 1.442697.923948 2.08873.79784 1.014292.859589 1.406361.452417 2.872584-.259343.933885-.472667 2.963327-.474043 4.509881-.0018 2.145155-.155996 2.811906-.649802 2.811906-.432868 0-.740279-.707912-.928011-2.137049z",
    fill: "#a9a0a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-78.292518 71.926596c-.732619-1.118119-.859521-3.239132-.866336-29.615889-.0046-17.763256.136591-27.736875.136591-27.736875s2.101397 2.27072 3.739884 4.134066c6.198168 7.048782 9.363638 13.309117 10.783786 21.327043.693084 3.913028.583357 11.331627-.213655 14.444769-.950365 3.712169-3.726453 9.341347-6.255788 12.685097-2.037082 2.692998-5.426004 5.96802-6.175578 5.96802-.197203 0-.71421-.542806-1.148904-1.206231z",
    fill: "#1f8c36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-79.111859 70.448681c.732616-1.118117-.05555-1.820784-.04873-28.197542.0046-17.763257.138324-27.677307.138324-27.677307-.229938.415374-2.307681 2.256905-3.946169 4.120251-6.19817 7.048781-9.36364 13.309117-10.783787 21.327044-.693084 3.913027-.583357 11.331626.213655 14.444768.950363 3.71217 3.726452 9.341347 6.255787 12.685097 2.037081 2.692999 6.432575 6.379797 7.182148 6.379797.197203 0 .554072-2.418682.98877-3.082108z",
    fill: "#31ae51"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.b6723cd258459b9ef671416c58a9fbc9.svg";
export { ForwardRef as ReactComponent };